"use client";

import React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
const partners = [{
  id: 1,
  name: "Cisco Systems",
  role: "Networking & Security Infrastructure",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/logo_cisco_systems.png"
}, {
  id: 2,
  name: "Dell Technologies",
  role: "Enterprise Server & Storage Solutions",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/logo_dell_tech.png"
}, {
  id: 3,
  name: "Microsoft",
  role: "Cloud & Software Ecosystem",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/logo_microsoft_corp.png"
}, {
  id: 4,
  name: "Marriott International",
  role: "Hospitality Infrastructure Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/logo_marriott_intl.png"
}, {
  id: 5,
  name: "VMware",
  role: "Virtualization & Cloud Computing",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/logo_vmware_inc.png"
}, {
  id: 6,
  name: "Fortinet",
  role: "Cybersecurity & Edge Protection",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/logo_fortinet_security.png"
}, {
  id: 7,
  name: "Sheraton Hotels",
  role: "Strategic Deployment Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/logo_sheraton_hotels.png"
}, {
  id: 8,
  name: "Veeam Software",
  role: "Data Protection & Backup Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/logo_veeam_software.png"
}];
export default function OurTrustedPartners() {
  const marqueeItems = [...partners, ...partners];
  return <section data-section-id="224102" id="strategic-procurement" className="bg-background py-16 md:py-24 overflow-hidden border-y border-border">
      <style>{`
        @keyframes marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee-scroll {
          animation: marquee-scroll 40s linear infinite;
        }
      `}</style>

      <div className="container mx-auto px-4 md:px-6 mb-10">
        <h2 className="text-center text-sm md:text-base font-default font-bold tracking-widest uppercase text-muted-foreground">
          The Procurement Advantage: Our Strategic Alliances
        </h2>
      </div>

      <div className="relative flex overflow-hidden group w-full">
        {}
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 md:w-32 bg-gradient-to-r from-background to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 md:w-32 bg-gradient-to-l from-background to-transparent" />

        <div className="flex w-max animate-marquee-scroll group-hover:[animation-play-state:paused] items-center gap-12 md:gap-24 px-6 md:px-12">
          {marqueeItems.map((partner, i) => <div data-index={i} key={`${partner.id}-${i}`} className="flex-shrink-0">
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className="flex items-center justify-center h-20 w-32 md:w-48 cursor-help transition-transform duration-300 hover:scale-105">
                    <img src={partner.logo} alt={`${partner.name} logo`} className="max-h-12 md:max-h-16 w-auto object-contain grayscale opacity-40 transition-all duration-500 ease-in-out hover:grayscale-0 hover:opacity-100" loading="lazy" />
                  </div>
                </TooltipTrigger>
                <TooltipContent side="bottom" className="font-default bg-card border-border text-foreground shadow-xl">
                  <p className="font-bold text-sm text-foreground">{partner.name}</p>
                  <p className="text-xs text-primary font-mono">
                    {partner.role}
                  </p>
                </TooltipContent>
              </Tooltip>
            </div>)}
        </div>
      </div>
    </section>;
}